export const form = {
  formCopyLink: 'Copiar enlace',
  formLinkCopied: 'Enlace copiado!'
}
